<template>
    <div class="shenbao-comments">
        <div class="comments-tag">
            <el-tag class="el-icon-chat-dot-round" type="warning" effect="dark"></el-tag><el-tag effect="dark" type="warning">{{`当前评论数${page.total}`}}</el-tag>
        </div>
        <el-card shadow="never" :body-style="{padding:'30px 0'}" class="bd-b1">
            <el-row>
                <el-col :span="24" class="m-b12">我要评论:</el-col>
                <el-col :span="24" class="m-b12">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" placeholder="请输入内容" v-model="text"></el-input>
                </el-col>
                <el-col :span="24" style="text-align:right">
                    <el-button type="primary" size="small" @click="setValuate">发表评论</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-card shadow="never" :body-style="{padding:'30px 0'}">
            <div>最新评论:</div>
            <el-card shadow="never" :body-style="{padding:'30px'}" class="bd-b1" v-for="(item,index) in list" :key="index">
                <el-row>
                    <el-col :span="2" style="text-align:center">
                        <el-avatar :size="50" :src="require('@/assets/imgs/analysis/avatar.png')"></el-avatar>
                    </el-col>
                    <el-col :span="22">
                        <div class="comments-user">{{`${item.nickname} : `}}</div>
                        <div class="comments-text">
                            {{item.comment}}
                        </div>
                    </el-col>
                </el-row>
            </el-card>
            <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total"
                :current-page="page.page"
                :page-size="page.limit"
                :pager-count="page.pagerCount"
                @current-change="handPageChange"
                style="margin-top:15px"
            ></el-pagination>
        </el-card>
    </div>
</template>
<script>
import { add , getValuateList} from '@/api/shenbao/shenbao-comments'
export default {
    data(){
        return {
            text:'',
            list:[],
            page: {
                page: 1,
                limit: 5,
                total: 0
            }
        }
    },
    props:{
        userInfo:{
            type:Object,
            default:()=>{}
        },
        shenbaoId:{
            type: Number,
            default:null
        }
    },
    watch:{
        shenbaoId: {
            immediate: true,
            handler: function (newVal) {
                if(newVal) this.getValuateList()
            }
        },
    },
    methods:{
        add(val){
            const { username , nickname } = this.userInfo
            let params = {
                username:username,
                nickname:nickname,
                comment:val,
                shenbaoId:this.shenbaoId
            }
            add(params).then(()=>{
                this.getValuateList()
                this.text = ""
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });
            })
        },
        setValuate(){
            if(this.text){
                this.$confirm('是否发表该评论?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add(this.text)
                }).catch(() => { });
            }
        },
        getValuateList(){
            const { page, limit } = this.page;
            let params = {
                shenbaoId: this.shenbaoId,
                sidx: 'create_time desc'
            }
            getValuateList(page,limit, params).then(res=>{
                const { totalCount, list } = res
                this.list = list
                this.$set(this.page,'total',totalCount)
            })
        },
        handPageChange(page) {
            this.$set(this.page, "page", page);
            this.getValuateList()
        },
    }
}
</script>
<style lang="less">
    .shenbao-comments{
        .m-b12{
            margin-bottom: 12px;
        }
        .comments-tag{
            padding-bottom: 24px;
            border-bottom: 1px solid #ccc;
            overflow: hidden;
            .el-tag{
                float: left;
            }
        }
        .el-card{
            border: none;
        }
        .bd-b1{
            border-bottom: 1px solid #ccc;
        }
        .comments-user{
            margin-bottom:12px
        }
        .comments-text{
            font-size: 14px;
            color: #8d8d8d;
        }
    }
</style>